module.exports = __webpack_public_path__ + "static/media/realtors-icon-17.5509afdf.svg";